import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { PagedList } from '../../common/common.types';
import {
	EventQuestionFilter,
	EventQuestion,
	EventQuestionWM
} from './event-question.types';
import * as qs from 'qs';

@Injectable()
export class EventQuestionService {
	private readonly questionUrl = 'api/eventQuestions';

	constructor(private http: HttpClient) { }

	getQuestions(questionFilter?: EventQuestionFilter): Promise<PagedList<EventQuestion>> {
		const params = new HttpParams({
			fromString: qs.stringify(questionFilter, { allowDots: true, skipNulls: true })
		});

		return this.http.get<PagedList<EventQuestion>>(this.questionUrl, { params: params })
			.toPromise();
	}

	getQuestion(questionId: number): Promise<EventQuestion> {
		return this.http.get<EventQuestion>(`${this.questionUrl}/${questionId}`)
			.toPromise();
	}

	createQuestion(newQuestion: EventQuestionWM): Promise<number> {
		return this.http.post<number>(this.questionUrl, newQuestion)
			.toPromise();
	}

	updateQuestion(questionId: number, updatedQuestion: EventQuestionWM): Promise<void> {
		return this.http.put<void>(`${this.questionUrl}/${questionId}`, updatedQuestion)
			.toPromise();
	}

	deleteQuestion(questionId: number): Promise<void> {
		return this.http.delete<void>(`${this.questionUrl}/${questionId}`)
			.toPromise();
	}
}
